module.exports = __webpack_public_path__ + "img/3.8e3f12ca.jpg";